import { template as template_8d8a42776a644d5cbbba565dadf2dab2 } from "@ember/template-compiler";
import { fn } from '@ember/helper';
import { gte } from 'ember-truth-helpers';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import ActionBanner from 'client-portal/components/site/action-banner';
import Component from '@glimmer/component';
import CoverageInfo from './channel/coverage-info';
import formatMoney from 'client-portal/helpers/format-money';
import rejectBy from 'ember-composable-helpers/helpers/reject-by';
import t from 'ember-intl/helpers/t';
export default class SiteBillingBalanceBanner extends Component {
    @service
    billingModals;
    @service
    billingPaymentCoordinator;
    get clientPaymentEnabled() {
        return this.billingModals.client?.permissions?.payments;
    }
    get practiceStripeEnabled() {
        return this.billingModals.hasCustomStripeAccount;
    }
    get disablePayNowButton() {
        return this.billingModals.refreshBillingProfile.isRunning;
    }
    get clientHasBalanceDue() {
        return this.args.client?.clientBillingOverview?.balanceDue > 0;
    }
    get showPayNowButton() {
        return this.clientHasBalanceDue && this.clientPaymentEnabled && this.practiceStripeEnabled;
    }
    static{
        template_8d8a42776a644d5cbbba565dadf2dab2(`
    <ActionBanner>
      <span
        class="text center{{unless this.showPayNowButton ' button-hidden'}}"
        data-test-balance-due
      >
        {{if
          (gte @client.clientBillingOverview.balanceDue 0)
          (t "billing.states.totalBalance")
          (t "billing.states.youHaveCredit")
        }}
        <strong>{{formatMoney @client.clientBillingOverview.balanceDue noPrefix=true}}</strong>

        {{#let
          (rejectBy "remainingSessionsCount" 0 @client.monarchChannelClientInfos)
          as |coveredChannels|
        }}
          {{#each coveredChannels as |channelClientInfo|}}
            <br />
            <CoverageInfo @channelClientInfo={{channelClientInfo}} />
          {{/each}}
        {{/let}}
      </span>

      {{#if this.showPayNowButton}}
        <button
          class="button primary"
          data-test-show-payment
          {{on "click" (fn this.billingPaymentCoordinator.showPayment null)}}
          type="button"
          disabled={{this.disablePayNowButton}}
        >
          {{t "billing.actions.payNow"}}
        </button>
      {{/if}}
    </ActionBanner>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
